"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
var _vue = _interopRequireDefault(require("vue"));
var _SvgIcon = _interopRequireDefault(require("@/components/SvgIcon"));
// svg component

// register globally
_vue.default.component('svg-icon', _SvgIcon.default);
const req = require.context('./svg', false, /\.svg$/);
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);